import { MENU_SHOW, MENU_HIDE } from "../store/config";

const menuInit = {
	view: true,
	timestamp: undefined
};

const menu = (state = menuInit, action) => {
	switch (action.type) {
		case MENU_SHOW:
			return {
				...state,
				view: action.payload,
				timestamp: action.timestamp
			}
		case MENU_HIDE:
			return {
				...state,
				view: action.payload,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default menu;


// WEBPACK FOOTER //
// ./src/reducers/menu.js